import { DemographyReq, DemographyDef } from "../type/demography";

export class DemographyAdapter {
  static toInputDTO(req: DemographyReq): any {
    const axes = req.subject_attrs.filter((attr) => attr.value);
    return {
      axes: axes.slice(0, 2).map((attr, index) => ({
        id: index,
        name: attr.key,
        axis: index === 0 ? "x" : "y",
      })),
      ...(req.required_nodes?.length
        ? { required_nodes: req.required_nodes }
        : {}),
    };
  }

  static toOutputDTO(res: any): DemographyDef {
    if (!res || res.length === 0) return {};

    const subject_count = res.reduce(
      (sum: number, item: any) => sum + (item.n_subjects || 0),
      0
    );

    // 表示は value_label を優先 (新DB: 20代/男性 等)。無い (legacy) ときは生値のままにし、
    // 従来どおり config-def 側でラベル解決させる。空文字も生値へフォールバック。
    const pick = (label: any, raw: string): string =>
      label != null && label !== "" ? String(label) : raw;
    const xLabels: any[] = res[0].x_axis.value_labels ?? [];

    const bar = {
      id: 1,
      key: res[0].x_axis.name,
      dataKey: res[0].level.name,
      values: res[0].x_axis.values.map((x: string, idx: number) => {
        const entry: any = {};
        entry[res[0].x_axis.name] = pick(xLabels[idx], x);
        res.forEach((item: any) => {
          entry[pick(item.level.value_label, item.level.value)] =
            item.values[idx];
        });
        return entry;
      }),
    };

    const xValues: string[] = res[0].x_axis.values;
    const pieAge = {
      id: 1,
      key: res[0].x_axis.name,
      values: xValues.map((x: string, idx: number) => {
        const total = res.reduce(
          (sum: any, item: any) => sum + (item.values[idx] || 0),
          0
        );
        return { id: idx + 1, key: pick(xLabels[idx], x), value: total };
      }),
    };

    const pieGender = {
      id: 2,
      key: res[0].level.name,
      values: res.map((item: any, idx: number) => {
        const total = item.values.reduce(
          (sum: number, val: number) => sum + val,
          0
        );
        return {
          id: idx + 1,
          key: pick(item.level.value_label, item.level.value),
          value: total,
        };
      }),
    };

    return {
      subject_count,
      bar,
      pie: [pieAge, pieGender],
    };
  }
}
